import {
    Field,
    FormikProps
} from 'formik';


import {
    Box,
    SimpleGrid
} from '@mantine/core';
import {PacFormikInput} from "@pac/platform-ui-components";
import {Credentials} from "../../credentials/types.ts";


export const FormComponent = (_props: FormikProps<Credentials>) => {
    return (
        <SimpleGrid>
            <Box>
                <Field
                    type="password"
                    name="otc"
                    placeholder="One Time Code (OTC)"
                    component={PacFormikInput}
                />
            </Box>

            <Box>
                <Field
                    type="password"
                    name="new_password"
                    placeholder="New Password"
                    component={PacFormikInput}
                />
            </Box>

            <Box>
                <Field
                    type="password"
                    name="confirm_password"
                    placeholder="Confirm Password"
                    component={PacFormikInput}
                />
            </Box>
        </SimpleGrid>
    );
};


